
/**
 * 工作流-大模型节点
 * zxw
 * 创建时间 2026-03-18
 */

import CNF from '../../incs/Config';
import { winHeight } from '../../incs/FunHelper';
import { convertVariableTags, formattedContent } from '../../components/MultifunctionalInput';
import { useState, useEffect } from 'react';
import {
    ConfigProvider,
    Modal,
    Avatar,
    Space,
    Divider,
    Input,
    Select,
    Button,
    Tag,
    Typography,
} from 'antd';
import {
    CheckOutlined,
    EditOutlined,
} from '@ant-design/icons';
import ContentEditable from "react-contenteditable";

import NodeVariableModel from './NodeVariableModel.js';

const { Text, Paragraph } = Typography;

const LLMNodeEntity = (props) => {
    const [open, setOpen] = useState(false);
    const [model, setModel] = useState('');

    const [isEditTitle, setIsEditTitle] = useState(false);                           // 标题是否编辑
    const [currentTitle, setCurrentTitle] = useState(props.node.data?.title);        // 当前标题

    const [systemPrompt, setSystemPrompt] = useState('');                            // 系统提示词
    const [systemPromptIsFocused, setSystemPromptIsFocused] = useState(false);       // 系统提示词是否聚焦
    const [openSystemPromptVariable, setOpenSystemPromptVariable] = useState(false); // 开启系统提示词变量

    const [userPromptIsFocused, setUserPromptIsFocused] = useState(false);           // 用户提示词是否聚焦
    const [userPrompt, setUserPrompt] = useState('');                                // 用户提示词
    const [openUserPromptVariable, setOpenUserPromptVariable] = useState(false);     // 开启用户提示词变量

    const cancel = () => {
        setOpen(false);
        setIsEditTitle(false);
    }

    useEffect(() => {
        setOpen(props.open);
        setModel(props.node.data?.model?.label);                    // 初始化大模型
        setOpenSystemPromptVariable(false);
        setOpenUserPromptVariable(false);
        if (props.node.data?.input.system_prompt) {
            setSystemPrompt(props.node.data.input.system_prompt);  // 初始化系统提示词
        } else {
            setSystemPrompt('');
        }
        if (props.node.data?.input.user_prompt) {
            setUserPrompt(props.node.data.input.user_prompt);      // 初始化用户提示词
        } else {
            setUserPrompt('');
        }
    }, [props]);

    // 更新系统提示词
    useEffect(() => {
        props.node.setData({
            ...props.node.data,
            input: {
                system_prompt: convertVariableTags(systemPrompt),
            },
        });
    }, [systemPrompt]);

    // 更新用户提示词
    useEffect(() => {
        props.node.setData({
            ...props.node.data,
            input: {
                user_prompt: convertVariableTags(userPrompt),
            },
        });
    }, [userPrompt]);


    return (
        <ConfigProvider theme={{
            token: {
                colorPrimary: global.THEMECOLOR,
            },
        }}>
            <Modal
                title={
                    <Space>
                        <Avatar size='small' shape='square' icon={props.node.data?.icon} style={{ background: props.node.data?.theme, }} />
                        {
                            isEditTitle ? <Input
                                value={currentTitle}
                                onChange={(e) => {
                                    setCurrentTitle(e.target.value);
                                }}
                            /> : props.node.data?.title
                        }

                        {
                            isEditTitle ?
                                <Button color='primary' variant='link' icon={<CheckOutlined />} onClick={() => {
                                    props.node.setData({
                                        ...props.node.data,
                                        title: currentTitle,
                                    });
                                    setIsEditTitle(false);
                                }} />
                                :
                                <Button color='primary' variant='link' icon={<EditOutlined />} onClick={() => {
                                    setIsEditTitle(true);
                                }} />
                        }
                    </Space>
                }
                width={480}
                height={winHeight - CNF.menuHeight - CNF.basePadding * 2}
                style={{
                    top: CNF.menuHeight + CNF.basePadding,
                    right: 18,
                    position: 'absolute',
                    scrollbarWidth: 'thin',
                    overflowY: 'auto',
                    paddingRight: 1,
                }}
                mask={{
                    enabled: false,
                    closable: true,
                }}
                open={open}
                onCancel={cancel}
                footer={null}
            >
                <Divider style={{ marginLeft: '-25px', marginRight: '-25px', width: 'calc(100% + 50px)', }} />
                <Paragraph>
                    <Text>模型配置</Text>
                    <Select
                        placeholder='请选择模型'
                        style={{ width: '100%' }}
                        options={CNF.models.map(item => {
                            return {
                                label: <Space><Avatar size='small' src={item.logo} />{item.label}</Space>,
                                title: item.label,
                                options: item.versions,
                            }
                        })}
                        value={model ? model : undefined}
                        onChange={(value, options) => {
                            // 模型名称
                            const name = CNF.models.find(m => m.versions.some(v => v.value === options.value))?.name;
                            setModel(value);
                            props.node.setData({
                                ...props.node.data,
                                model: {
                                    ...options,
                                    name: name,
                                },
                            });
                        }}
                    />
                </Paragraph>
                <Divider style={{ marginLeft: '-25px', marginRight: '-25px', width: 'calc(100% + 50px)', }} />
                <Paragraph>
                    <Text>系统提示词</Text>
                    <div style={{
                        position: 'relative',
                        border: `1px solid ${systemPromptIsFocused ? props.colorPrimary : '#d9d9d9'}`,
                        padding: '10px 10px 2px 10px',
                        borderRadius: 6,
                        transition: 'all 0.2s',
                        boxShadow: `0 0 0 ${systemPromptIsFocused ? '1.5px' : '0'} ${props.colorPrimaryBg}`,
                    }}>
                        <div
                            style={{
                                height: 100,
                                scrollbarColor: '#d9d9d9 transparent',
                                scrollbarWidth: 'thin',
                                overflowY: 'auto',
                            }}
                            onFocus={() => setSystemPromptIsFocused(true)}
                            onBlur={() => {
                                setSystemPromptIsFocused(false);
                            }}
                        >
                            <ContentEditable
                                html={formattedContent(systemPrompt, props.graph)}                // 渲染带格式的 HTML
                                onChange={(e) => {
                                    setSystemPrompt(e.target.value ? e.target.value : '');
                                }}
                                tagName='div'
                                style={{ minHeight: '40px', outline: 'none' }}
                                onKeyDown={(e) => {
                                    // 只处理单字符按键（key 长度为 1 且不是修饰键）
                                    if (e.key.length === 1 && !e.ctrlKey && !e.altKey && !e.metaKey) {
                                        // 注意：e.key 已经考虑了 Shift，例如 Shift+a 得到 'A'
                                        // 输入“/或者、”弹出变量选项界面
                                        if (e.key === '/' || e.key === '、') {
                                            e.preventDefault();
                                            setOpenSystemPromptVariable(true);
                                        } else {
                                            setOpenSystemPromptVariable(false);
                                        }
                                    }
                                }}
                                onPaste={(e) => {
                                    e.preventDefault();
                                    const plainText = e.clipboardData.getData('text/plain');
                                    document.execCommand('insertText', false, plainText);
                                }}
                            />
                            <style>{`
                            .variable-tag {
                                background: #F5F6F8;
                                border-radius: 4px;
                                padding: 2px 6px;
                                margin: 0 4px;
                                color: ${props.colorTextBase};
                                user-select: all;
                                cursor: default;
                                font-size: ${CNF.fontSizeSM}px;
                            }
                            .variable-name {
                                color: ${props.colorPrimary};
                            }
                        `}</style>
                        </div>
                        <Text style={{ fontSize: CNF.fontSizeXS, color: CNF.basePlaceholderColor }}>输入“/”插入变量</Text>
                        {
                            openSystemPromptVariable ? <NodeVariableModel
                                graph={props.graph}
                                node={props.node}
                                value={systemPrompt}
                                setValue={setSystemPrompt}
                                cancel={setOpenSystemPromptVariable}
                            /> : ''
                        }
                    </div>
                </Paragraph>
                <Paragraph>
                    <Text>用户提示词</Text>
                    <div style={{
                        position: 'relative',
                        border: `1px solid ${userPromptIsFocused ? props.colorPrimary : '#d9d9d9'}`,
                        padding: '10px 10px 2px 10px',
                        borderRadius: 6,
                        transition: 'all 0.2s',
                        boxShadow: `0 0 0 ${userPromptIsFocused ? '1.5px' : '0'} ${props.colorPrimaryBg}`,
                    }}>
                        <div
                            style={{
                                height: 100,
                                scrollbarColor: '#d9d9d9 transparent',
                                scrollbarWidth: 'thin',
                                overflowY: 'auto',
                            }}
                            onFocus={() => setUserPromptIsFocused(true)}
                            onBlur={() => {
                                setUserPromptIsFocused(false);
                            }}
                        >
                            <ContentEditable
                                html={formattedContent(userPrompt, props.graph)}  // 渲染带格式的 HTML
                                onChange={(e) => {
                                    setUserPrompt(e.target.value ? e.target.value : '');
                                }}
                                tagName='div'
                                style={{ minHeight: '40px', outline: 'none' }}
                                onKeyDown={(e) => {
                                    // 只处理单字符按键（key 长度为 1 且不是修饰键）
                                    if (e.key.length === 1 && !e.ctrlKey && !e.altKey && !e.metaKey) {
                                        // 注意：e.key 已经考虑了 Shift，例如 Shift+a 得到 'A'
                                        // 输入“/或者、”弹出变量选项界面
                                        if (e.key === '/' || e.key === '、') {
                                            e.preventDefault();
                                            setOpenUserPromptVariable(true);
                                        } else {
                                            setOpenUserPromptVariable(false);
                                        }
                                    }
                                }}
                            />
                            <style>{`
                            .variable-tag {
                                background: #F5F6F8;
                                border-radius: 4px;
                                padding: 2px 6px;
                                margin: 0 4px;
                                color: ${props.colorTextBase};
                                user-select: all;
                                cursor: default;
                                font-size: ${CNF.fontSizeSM}px;
                            }
                            .variable-name {
                                color: ${props.colorPrimary};
                            }
                        `}</style>
                        </div>
                        <Text style={{ fontSize: CNF.fontSizeXS, color: CNF.basePlaceholderColor }}>输入“/”插入变量</Text>
                        {
                            openUserPromptVariable ? <NodeVariableModel
                                graph={props.graph}
                                node={props.node}
                                value={userPrompt}
                                setValue={setUserPrompt}
                                cancel={setOpenUserPromptVariable}
                            /> : ''
                        }
                    </div>
                </Paragraph>
                <Divider style={{ marginLeft: '-25px', marginRight: '-25px', width: 'calc(100% + 50px)', }} />
                <Paragraph>
                    <Text>输出变量</Text>
                    <div>
                        {
                            props.node?.data?.output && Object.keys(props.node?.data.output).map(key => {
                                return <div key={key}><Space><Text>{key}</Text><Tag style={{ color: props.colorBasePlaceholder }}>string</Tag></Space></div>
                            })
                        }
                    </div>
                </Paragraph>
            </Modal>
        </ConfigProvider >
    );
}

export default LLMNodeEntity;